var render, staticRenderFns
import script from "./RevenueAndProfitPieChart.vue?vue&type=script&lang=js&"
export * from "./RevenueAndProfitPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RevenueAndProfitPieChart.vue"
export default component.exports